/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./add-assist-account-dialog.vue?vue&type=template&id=428843e4&scoped=true&"
import script from "./add-assist-account-dialog.vue?vue&type=script&lang=ts&"
export * from "./add-assist-account-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./add-assist-account-dialog.vue?vue&type=style&index=0&id=428843e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428843e4",
  null
  
)

export default component.exports